import * as React from "react";

import { ColorWarning } from "./theme";

export const WarningIcon = ({
  fill,
  width,
  height,
}: {
  fill?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "14"}
      viewBox="0 0 35 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.6027 24.7583L20.404 1.89763C19.718 0.70942 18.4893 0 17.1172 0C15.7451 0 14.5164 0.70942 13.8303 1.89763L0.631721 24.7583C-0.0543237 25.9466 -0.0543237 27.3653 0.631721 28.5536C1.31777 29.7418 2.54648 30.4513 3.91857 30.4513H30.3159C31.6879 30.4513 32.9167 29.7418 33.6027 28.5536C34.2887 27.3654 34.2887 25.9466 33.6027 24.7583ZM16.1204 10.1824H18.114V20.483H16.1204V10.1824ZM17.1172 25.1349C16.3843 25.1349 15.7881 24.5386 15.7881 23.8058C15.7881 23.0729 16.3843 22.4766 17.1172 22.4766C17.85 22.4766 18.4463 23.0729 18.4463 23.8058C18.4463 24.5386 17.85 25.1349 17.1172 25.1349Z"
        fill={fill || ColorWarning.dark}
      />
    </svg>
  );
};
